module.exports = __webpack_public_path__ + "static/img/xing.36fae44b.svg";